import { SECURITY_JWT_KEY } from "config/globals"

export const saveToken = (token: string) => {
    localStorage.setItem(SECURITY_JWT_KEY, token)
}
